export default {
  SELECTED_LOCATION: 'MOSMOSH_SELECTED_LOCATION',
  NEWSLETTER_SIGNED_UP: 'NEWSLETTER_SIGNED_UP',
  RELEWISE_TEMPORARY_ID: 'RELEWISE_TEMPORARY_ID'
};
